import React, { Component } from 'react';
import { Grid, List, ListItem, Box, Typography, Hidden } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import style from './style';
const moment = require("moment");

class FooterLoggedIn extends Component {
	render() {
		let year = moment().format('YYYY');
		return (
			<Grid container style={{ marginTop: '80px', paddingLeft: '5%', paddingRight: '5%'}}>
				<Box display="flex" width="100%" className="footer-top">
					<Grid className="footer-block">
						<Box>
							<List>
								<ListItem>
									<a
										href="/home/dashboard"
										onClick={() => {
											document.body.scrollTop = 0;
											document.documentElement.scrollTop = 0;
											return true;
										}}
										style={style.listItem}
									>Home</a>
								</ListItem>
								<ListItem>
									<Link
										to="/home/saved"
										style={style.listItem}
									>Saved</Link>
								</ListItem>
								<ListItem>
									<Link
										to={this.props.isChef ? "/home/chef-bookings" : "/home/diner-bookings"}
										style={style.listItem}
									>Bookings</Link>
								</ListItem>
							</List>
						</Box>
						<Box>
							<List>
								<ListItem>
									<Link
										to="/home/chef-search"
										style={style.listItem}
									>Chefs</Link>
								</ListItem>
								<ListItem>
									<a
										href={'/home/dish-search?all=true'}
										style={style.listItem}
									>Dishes</a>
								</ListItem>
								<ListItem>
									<Link
										to="/home/post-search"
										style={style.listItem}
									>Posts</Link>
								</ListItem>
							</List>
						</Box>
						<Box>
							<List>
								<ListItem>
									<Link
										to="/home/about-us"
										style={style.listItem}
									>About Us</Link>
								</ListItem>
								<ListItem>
									<Link
										to="/home/privacy-policy"
										style={style.listItem}
									>Privacy Policy</Link>
								</ListItem>
								<ListItem>
									<Link
										to="/home/terms-of-use"
										style={style.listItem}
									>Terms &amp; Conditions</Link>
								</ListItem>
							</List>
						</Box>
						<Box className="app-icons" style={{marginTop: 16}}>
							{/*<Hidden xsDown>
								<Typography compnent="p" style={{...style.setFont, ...style.downloadApp}}>DOWNLOAD APP</Typography><br />
								<Link to="/">
									<img src="/images/appStore.webp" alt="App Store" style={style.storeImage} />
								</Link>
								<Link to="/">
									<img src="/images/playStore.webp" alt="Play Store" style={style.storeImage} />
								</Link>
							</Hidden>*/}
						</Box>
					</Grid>
				</Box>

				<Box display="flex" width="100%" className="copy-right-section">
					<Grid container className="bottom-footer">
						<Hidden smDown>
							<Grid item xs={4} md={8}>
								<img src="/images/logo.webp" alt="Cuisine Crafters" style={style.logo} />
							</Grid>

							<Grid item xs={8} md={4}>
								<Typography component="p" style={style.footerNote}>&copy; Copyright {year}. Cuisine Crafters</Typography>
							</Grid>
						</Hidden>

						<Hidden mdUp>
							<br /><br /><br />
							<Grid item xs={4} style={style.mobileStore}>
								<img src="/images/logo.webp" alt="Cuisine Crafters" style={style.logo} />
							</Grid>

							<Grid item xs={8} style={style.mobileStore}>
								<Typography component="p" style={style.footerNote}>&copy; Copyright {year}. Cuisine Crafters</Typography>
							</Grid>
						</Hidden>
					</Grid>
				</Box>
			</Grid>
		);
	}
}

function mapStateToProps(state) {
	return {
		isChef: state.auth.isChef,
		userId: state.auth.userId,
	};
}

const Footer = connect(mapStateToProps)(FooterLoggedIn);

export default Footer;
